module.exports = __webpack_public_path__ + "static/media/emoji_graph1.12e550fa.svg";